import { render } from "./TeamPage.vue?vue&type=template&id=72aeb90a&scoped=true"
import script from "./TeamPage.vue?vue&type=script&lang=js"
export * from "./TeamPage.vue?vue&type=script&lang=js"

import "./TeamPage.vue?vue&type=style&index=0&id=72aeb90a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72aeb90a"]])

export default __exports__